var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legal-page legal-page--in-app",attrs:{"dir":_vm.isRtl ? 'rtl' : 'ltr'}},[_c('div',{staticClass:"legal-page__main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }